import React from "react";
import { Link, Outlet } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../hooks/redux-hooks";
import { Navigate, useLocation } from "react-router-dom";

const DefaultLayout = () => {
  const location = useLocation();
  // console.log('当前路径:', location.pathname);
  // console.log('来源状态:', location.state);
  // console.log('完整位置对象:', location);

  const basicUserInfo = useAppSelector((state) => state.auth.basicUserInfo);
  const driverInfo = useAppSelector((state) => state.auth.driverInfo);
  const publicPaths = [
    "/query-order",
    "/privacy-policy",
    "/terms-of-service",
    "/forgot-password",
    "/reset-password",
  ];

  // 如果不这么做，admin的查询过来，需要user必须是登陆状态
  if (publicPaths.includes(location.pathname)) {
      return (
      <>
        <Outlet />
      </>
    );
  }

  if (basicUserInfo && location.pathname !== "/driver-login") {
    //return <Navigate replace to={"/"} />;
    return <Navigate replace to={"/select"} />;
  }

  if (driverInfo && location.pathname !== "/login") {
    return <Navigate replace to={"/driver-select"} />;
  }

  return (
    <>
      <Outlet />
    </>
  );
};

export default DefaultLayout;
